import { getGqlEndpoint } from '../../fetch';
import { fetchFromGql } from './fetch';
import { fetchJsonGql } from './fetch-json-gql';
import type { GraphQLResponse } from './response';
import type { GqlRequestExtensions, PersistedQuery } from './types';

interface GqlApqRequestExtensions extends Omit<GqlRequestExtensions, 'persistedQuery'> {
  persistedQuery: PersistedQuery;
}

interface FetchQueryParamsGqlArgs<GqlVariables = unknown> {
  variables?: GqlVariables;
  extensions: GqlApqRequestExtensions;
}

/**
 * according to:
 * https://support.microsoft.com/en-us/topic/maximum-url-length-is-2-083-characters-in-internet-explorer-174e7c8a-6666-f4e0-6fd6-908b53c12246
 */
const GET_CHAR_LIMIT = 2048;

const safeForGetMethod = (url: string) => location.origin.length + url.length < GET_CHAR_LIMIT;

const getQueryParamsString = <GqlVariables = unknown>({
  extensions,
  variables,
}: FetchQueryParamsGqlArgs<GqlVariables>) => {
  const searchParams = new URLSearchParams();

  searchParams.set('extensions', JSON.stringify(extensions));
  if (variables) {
    searchParams.set('variables', JSON.stringify(variables));
  }

  return searchParams.toString();
};

export const fetchQueryParamsGql = <ResponseData, GqlVariables = unknown>(
  args: FetchQueryParamsGqlArgs<GqlVariables>
) => {
  const url = `${getGqlEndpoint()}?${getQueryParamsString(args)}`;
  if (safeForGetMethod(url)) {
    return fetchFromGql<GraphQLResponse<ResponseData>>({ url });
  } else {
    return fetchJsonGql<ResponseData>(args);
  }
};
